import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, select, takeLatest } from "redux-saga/effects"
import { handleError } from "app/redux/errorHandler/errorHandler.saga"
import { getMonthRange } from "utils"
import * as actions from "./hrUnavailabilities.actions"
import * as absencesTableSelectors from "../absencesTable/absencesTable.selectors"
import * as absencesTableActions from "../absencesTable/absencesTable.actions"
import * as notificationActions from "../notifications/notifications.actions"

export function* getHrUnavailabities(action: actions.GetHrUnavailabilitiesAction): SagaIterator {
  try {
    const { data } = yield call(api.getHrUnavailabilities, action.payload.params)
    yield put(actions.getHrUnavailabilitiesSuccess(data))
  } catch (e) {
    yield put(actions.getHrUnavailabilitiesFail(e))
    yield call(handleError, { error: e })
  }
}

export function* postHrUnavailabities(action: actions.PostHrUnavailabilitiesAction): SagaIterator {
  try {
    const { hrUnavailabilities } = action.payload
    const {
      data: { success },
    } = yield call(api.postHrUnavailabilities, hrUnavailabilities)
    const range = getMonthRange(hrUnavailabilities[0].date)
    const userParams = yield select(absencesTableSelectors.getUserParams)
    yield put(absencesTableActions.getAbsences(range, userParams))
    yield put(actions.postHrUnavailabilitiesSuccess(success))
    yield put(
      notificationActions.show({
        id: "postRequest",
        message: "confirmationDialog.requests.create.message",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.postHrUnavailabilitiesFail(e))
    yield call(handleError, { error: e })
  }
}

export function* patchHrUnavailabities(action: actions.PatchHrUnavailabilitiesAction): SagaIterator {
  try {
    const { hrUnavailabilities } = action.payload
    const { data } = yield call(api.patchHrUnavailabilities, action.payload.hrUnavailabilities)
    const range = getMonthRange(hrUnavailabilities[0].date!)
    const userParams = yield select(absencesTableSelectors.getUserParams)
    yield put(absencesTableActions.getAbsences(range, userParams))
    yield put(actions.patchHrUnavailabilitiesSuccess(data))
  } catch (e) {
    yield put(actions.postHrUnavailabilitiesFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* hrUnavailabilitiesSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getHrUnavailabities)
  yield takeLatest(actions.Types.POST, postHrUnavailabities)
  yield takeLatest(actions.Types.PATCH, patchHrUnavailabities)
}
